const RELOADED_AT_KEY = 'dixa:stale-chunk-reloaded-at';
const MIN_RELOAD_INTERVAL_MS = 60_000;

/**
 * Recovers from stale-deploy chunk loading failures.
 *
 * When a lazy route's chunk (or one of its preloaded dependencies) fails to
 * load — typically because the tab predates the latest deploy — a reload
 * fetches the fresh `index.html`, whose imports reference the current chunk
 * graph, and the navigation succeeds on retry.
 *
 * The reload is rate-limited per tab: if a chunk failure repeats within the
 * interval, the failure is persistent (an ad blocker, a broken deploy, a
 * network outage) and reloading again would loop. In that case the event is
 * left unhandled so the error propagates to the error boundary and Sentry,
 * exactly as it did before this handler existed.
 */
export function installStaleChunkReload(): void {
  window.addEventListener('vite:preloadError', (event) => {
    const reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY) ?? 0);
    if (Date.now() - reloadedAt < MIN_RELOAD_INTERVAL_MS) {
      return;
    }
    sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    event.preventDefault();
    window.location.reload();
  });
}
